import { Component, Input } from '@angular/core'
import { ModalService } from '@shared/services'

@Component({
  selector: 'app-tables-info',
  standalone: true,
  imports: [],
  templateUrl: './tables-info.component.html',
  styleUrl: './tables-info.component.sass',
})
export class TablesInfoComponent {
  constructor(private _modalService: ModalService) {}

  @Input() foldCost: number = 0
  @Input() buyInCost: number = 0
  @Input() minBet: number = 0
  @Input() maxBet: number = 0

  closeModal() {
    this._modalService.closeTableInfoModal()
  }
}
